import React from 'react';
import BoldVerticalBarChart, {
	BoldVerticalBarChartProps,
} from '@components/report/chart/bold-vertical-bar-chart/BoldVerticalBarChart';
import VerticalBarAverageChart, {
	VerticalBarAverageChartProps,
} from '@components/report/chart/vertical-bar-average-chart/VerticalBarAverageChart';
import ReportCard from '@components/report/report-card/ReportCard';
import { threeDivisionGridClass } from '@components/report/style.css';

export interface EngagementIgProps {
	averageLikes?: VerticalBarAverageChartProps;
	averageComments?: VerticalBarAverageChartProps;
	engagementRate?: BoldVerticalBarChartProps;
	isLoading?: boolean;
	isError?: boolean;
	lackOfPermission?: boolean;
}

const EngagementIg = ({
	averageLikes,
	averageComments,
	engagementRate,
	isLoading,
	isError,
	lackOfPermission,
}: EngagementIgProps) => {
	const status = { isLoading, isError, lackOfPermission };
	return (
		<div className={threeDivisionGridClass}>
			<ReportCard
				label="평균 좋아요 수"
				tooltip="최근 24개의 콘텐츠(피드 및 동영상)를 기준으로 계산된 평균 좋아요 수입니다."
				lackOfPermission={lackOfPermission}
			>
				<VerticalBarAverageChart
					subDesc="최근 콘텐츠 24개 기준"
					valueUnit="개"
					label="평균 좋아요 수"
					desc={true}
					{...averageLikes}
					{...status}
				/>
			</ReportCard>
			<ReportCard
				label="평균 댓글 수"
				tooltip="최근 24개의 콘텐츠(피드 및 동영상)를 기준으로 계산된 평균 댓글 수입니다."
				lackOfPermission={lackOfPermission}
			>
				<VerticalBarAverageChart
					subDesc="최근 콘텐츠 24개 기준"
					valueUnit="개"
					label="평균 댓글 수"
					desc={true}
					{...averageComments}
					{...status}
				/>
			</ReportCard>
			<ReportCard
				label="참여율(ER)"
				tooltip="최근 24개의 콘텐츠(피드 및 동영상)를 기준으로 계산된 계정의 평균 참여율을 나타냅니다. 참여율은 좋아요, 댓글과 같은 상호작용 수를 팔로워 수로 나눈 값으로, 계정의 콘텐츠가 얼마나 활발하게 참여를 이끌어내는지를 나타내는 지표입니다."
				lackOfPermission={lackOfPermission}
			>
				<BoldVerticalBarChart
					subDesc="최근 콘텐츠 24개 기준"
					desc
					data={[{ isMain: true }, {}]}
					{...engagementRate}
					{...status}
				/>
			</ReportCard>
		</div>
	);
};

export default EngagementIg;
